import {
  SiC, SiCplusplus, SiCss3, SiDocker, SiHtml5, SiJavascript,
  SiMysql, SiPhp, SiPython, SiReact, SiTailwindcss, SiTypescript,
  SiUipath, SiFastapi, SiDjango, SiGit, SiOpencv, SiLaravel
} from 'react-icons/si';

// ── Hero ──────────────────────────────────────────────────────────────────
export const heroData = {
  name: 'Er. Guptaraj Shrestha',
  description:
    'I build responsive and user-focused web applications using React, while leveraging my backend expertise in PHP and Python to create scalable full-stack solutions.',
  // description:
  //   'I build interactive and seamless web experiences while leveraging my backend knowledge in PHP and Python for full-stack solutions.',
  roles: ['Computer Engineer', 'Frontend Developer', 'RPA Developer', 'Data Science Student'],
  socialLinks: [
    { type: 'github', url: 'https://github.com/guptarajStha' },
    { type: 'linkedin', url: 'https://www.linkedin.com/in/guptaraj-shrestha-a813481a6/' },
    { type: 'email', url: 'mailto:guptarajshrestha@gmail.com' },
  ],
};

// ── About ─────────────────────────────────────────────────────────────────
export const aboutData = {
  profileImage: '/images/Guptaraj-Shrestha.webp',
  initials: 'GS',
  description: [
    "I'm a passionate developer with experience building full-stack applications, CMS projects, and real-time web platforms. My technical skills span ReactJS, TailwindCSS, HTML, CSS, and JavaScript, as well as backend work in PHP and Python (FastAPI).",
    'I enjoy turning complex problems into efficient, user-friendly solutions and focus on writing clean, maintainable code. Currently pursuing an MSc in Data Science & Analytics at Tribhuvan University, Pulchowk Campus.',
  ],
  stats: [
    { value: '2+', label: 'Years Exp' },
    { value: '5+', label: 'Projects' },
    { value: '1', label: 'Publication' },
  ],
  features: [
    { icon: '⚡', title: 'Clean Code', desc: 'Maintainable, scalable code following best practices.' },
    { icon: '🎨', title: 'Creative Design', desc: 'Transforming ideas into user-friendly interfaces.' },
    { icon: '🚀', title: 'Performance', desc: 'Optimizing for speed and exceptional UX.' },
    { icon: '🤝', title: 'Collaboration', desc: 'Working effectively in cross-functional teams.' },
  ],
};

// ── Skills (for GSAP marquee) ─────────────────────────────────────────────

const SZ = 42;

export const techStack = [
  { icon: SiReact, name: 'React', color: '#61DAFB', size: SZ },
  { icon: SiLaravel, name: 'Laravel', color: '#F05032', size: SZ },
  { icon: SiJavascript, name: 'JavaScript', color: '#F7DF1E', size: SZ },
  { icon: SiTypescript, name: 'TypeScript', color: '#3178C6', size: SZ },
  { icon: SiTailwindcss, name: 'TailwindCSS', color: '#06B6D4', size: SZ },
  { icon: SiHtml5, name: 'HTML5', color: '#E34F26', size: SZ },
  { icon: SiCss3, name: 'CSS3', color: '#1572B6', size: SZ },
  { icon: SiPhp, name: 'PHP', color: '#777BB4', size: SZ },
  { icon: SiPython, name: 'Python', color: '#3776AB', size: SZ },
  { icon: SiFastapi, name: 'FastAPI', color: '#009688', size: SZ },
  { icon: SiDjango, name: 'Django', color: '#092E20', size: SZ },
  { icon: SiMysql, name: 'MySQL', color: '#4479A1', size: SZ },
  { icon: SiUipath, name: 'UiPath', color: '#FA4616', size: SZ },
  { icon: SiDocker, name: 'Docker', color: '#2496ED', size: SZ },
  { icon: SiGit, name: 'Git', color: '#F05032', size: SZ },
  { icon: SiOpencv, name: 'OpenCV', color: '#5C3EE8', size: SZ },
  { icon: SiC, name: 'C', color: '#A8B9CC', size: SZ },
  { icon: SiCplusplus, name: 'C++', color: '#00599C', size: SZ },
];

// ── Experience ────────────────────────────────────────────────────────────
export const experiences = [
  {
    role: 'Frontend Developer (React)',
    type: 'Full-time · Onsite',
    company: 'Midas Education Pvt. Ltd.',
    duration: 'Nov 2025 – Present',
    bullets: [
      'Building and maintaining modern, scalable frontend applications using React.',
      'Collaborating with backend teams to integrate APIs and optimize UI performance.',
      'Ensuring clean, reusable component architecture across the codebase.',
    ],
    tech: ['React', 'React Native', 'TailwindCSS', 'Ant Design', 'Laravel', 'PostgreSQL'],
  },
  {
    role: 'Associate Software Engineer',
    type: 'Full-time · Onsite',
    company: 'Bent Ray Technologies',
    duration: 'Sep 2024 – Nov 2025',
    bullets: [
      'Built and integrated backend APIs for CMS and enterprise systems.',
      'Contributed to an OCPP-based EV Charging Management System.',
      'Delivered SAP automation solutions using UiPath.',
    ],
    tech: ['PHP', 'Python', 'FastAPI', 'UiPath', 'MySQL', 'OCPP'],
  },
  {
    role: 'Software Engineer Intern',
    type: 'Full-time · Onsite',
    company: 'Bent Ray Technologies',
    duration: 'Aug 2024 – Sep 2024',
    bullets: [
      'Assisted in developing responsive web interfaces and backend features.',
      'Gained hands-on experience with REST APIs and collaborative development.',
    ],
    tech: ['JavaScript', 'PHP', 'MySQL', 'jQuery'],
  },
];

// ── Projects (with real images from /public/images/) ──────────────────────
export const projects = [
  {
    title: 'School Management Information System',
    image: '/images/school-management.png',
    description:
      'Developed web and mobile frontend modules including Student Accounts, PIS, Results, Analytics, Student Management, and Dynamic Forms using React and React Native.',
    tags: ['React', 'React Native', 'TailwindCSS', 'Redux', 'REST API'],
    github: '',
    playStore: 'https://play.google.com/store/apps/details?id=com.teacherscopilot.smisapp',
    demo:''
  },
  {
    title: 'EV Charging Management System',
    image: '/images/charging.png',
    description:
      'Management system for electric vehicle charging stations using OCPP. Built backend APIs with FastAPI and handled real-time communication with EVSEs.',
    tags: ['Python', 'OCPP', 'FastAPI', 'Websocket'],
    github: '',
    demo: '',
  },
  {
    title: 'SAP Automation with UiPath',
    image: '/images/uipath.png',
    description:
      'Designed and implemented automation workflows in SAP using UiPath, automating repetitive business tasks and improving operational efficiency.',
    tags: ['UiPath', 'RPA', 'SAP'],
    github: '',
    demo: '',
  },
  {
    title: 'Reliance Residential CMS Website',
    image: '/images/image.png',
    description:
      'Custom CMS website designed, developed, and deployed on cPanel with dynamic content management and responsive design.',
    tags: ['PHP', 'Yii2', 'MySQL', 'Freelance'],
    github: '',
    demo: 'https://relianceresidential.edu.np/',
  },
  {
    title: 'NSL Letter Detection & Finger Spelling',
    image: '/images/major.png',
    description:
      "Bachelor's major project — web-based Nepali Sign Language alphabet detection using Mediapipe and CNN. Published at IOEGC 2024.",
    tags: ['Mediapipe', 'CNN', 'Django', 'React'],
    github: 'https://github.com/guptarajStha/nsl_finger_spelling',
    demo: 'https://drive.google.com/file/d/1E_JsaeBNztXwpiZGfE7574UYsnxSpiFq/view',
  },
  {
    title: 'Dyslexic Detection System',
    image: '/images/minor.png',
    description:
      "Bachelor's minor project — web app predicting dyslexia vs non-dyslexia based on questionnaire responses using Naive Bayes classifier.",
    tags: ['Python', 'Django', 'Naive Bayes', 'React'],
    github: 'https://github.com/guptarajStha/minor_Project',
    demo: '',
  },
];

// ── Education ─────────────────────────────────────────────────────────────
export const education = [
  {
    year: '2025 – Present',
    degree: 'M.Sc. in Computer Engineering — Data Science & Analytics',
    school: 'Tribhuvan University, Pulchowk Campus, IOE',
    badge: 'Currently pursuing',
  },
  {
    year: '2019 – 2024',
    degree: 'Bachelor of Engineering in Computer Engineering',
    school: 'Tribhuvan University, Purwanchal Campus, IOE',
    badge: '72.93%',
  },
  {
    year: '2017 – 2019',
    degree: 'NEB +2 in Science',
    school: 'Greenland International College, Biratnagar',
    badge: 'CGPA 3.45',
  },
];

export const certifications = [
  {
    icon: '📄',
    name: 'NSL Letter Detection and Finger Spelling Using Mediapipe and CNN',
    issuer: 'Proceedings of 15th IOE Graduate Conference · May 2024',
    link: 'https://conference.ioe.edu.np/publications/ioegc15/IOEGC-15-025-C1-4-63.pdf',
  },
  {
    icon: '🏆',
    name: 'Best AI Award — Delta 4.0 National Level Software Hackathon',
    issuer: 'ACES, IOE Purwanchal Campus Dharan · January 2024',
    link: '',
  },
];

// ── Contact ───────────────────────────────────────────────────────────────
export const contactInfo = [
  { icon: 'email', label: 'Email', value: 'guptarajshrestha@gmail.com', href: 'mailto:guptarajshrestha@gmail.com' },
  { icon: 'phone', label: 'Phone', value: '+977 9805963271', href: 'tel:+9779805963271' },
  { icon: 'location', label: 'Location', value: 'Bhaktapur, Nepal', href: '#' },
];
